import { Action } from '@ngrx/store';

export interface FleetUserState {
  user,
  fleet
}

export const initialState: FleetUserState = {
  fleet:{
    name:'',
    description:''
  },
  user: {
    id: '',
    username: '',
    password: '',
    first_name: '',
    last_name: '',
    title: {
      id: '2',
      display: 'Mrs'
    }
  }
};

export function fleetUserReducer(state = initialState, action: Action): FleetUserState {
  switch (action.type) {

    default:
      return state;
  }
}
